import { type MaintenanceChecklistField } from '@gb-ticket/shared-types';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ChecklistFieldShell } from '@/products/maintenance/features/protocol-renderer/checklist-field-shell';

type ChoiceField = Extract<MaintenanceChecklistField, { type: 'choice' }>;

type Props = {
  field: ChoiceField;
  readOnly?: boolean;
};

export function ChecklistChoiceField({ field, readOnly = true }: Props) {
  return (
    <ChecklistFieldShell field={field}>
      <Select value={field.options[0]?.value} disabled={readOnly}>
        <SelectTrigger className="w-full" aria-label={field.label}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {field.options.map((opt) => (
            <SelectItem key={opt.value} value={opt.value || 'none'}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </ChecklistFieldShell>
  );
}
